var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"improvement",attrs:{"name":"improvement"}},[(_vm.isPost)?_c('post',{on:{"onClose":_vm.closePost,"onSubmit":_vm.submitUncomfortable}}):_vm._e(),_vm._v(" "),_c('improvement-banner',{on:{"postUncomfortable":_vm.postUncomfortable}}),_vm._v(" "),_c('improvement-list')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2be30f2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/m_uncomfortable/Improvement.vue
// module id = null
// module chunks = 